import React from 'react';
import { Star } from 'lucide-react';
interface HeroProps {
  onCTAClick: () => void;
}
export function Hero({
  onCTAClick
}: HeroProps) {
  const opinions = [{
    name: 'María L.',
    text: 'Me cambió la forma de trabajar, ahora todo está organizado.'
  }, {
    name: 'Laura S.',
    text: 'Las plantillas me ahorran horas cada semana.'
  }, {
    name: 'Gabriela M.',
    text: 'Profesional y completo, lo recomiendo 100%.'
  }];
  return <section className="w-full bg-gradient-to-b from-teal-50 to-white py-12 px-4" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        {/* Title */}
        <h1 className="text-2xl md:text-4xl font-bold text-center text-gray-900 mb-6 leading-tight" data-id="element-86">
          El Sistema para acompañantes que quieren dejar de llevarse trabajo a
          casa
        </h1>

        {/* Main Product Image */}
        <div className="flex justify-center mb-8" data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/epd2WpUcTqmcwASJFECuRJ/ChatGPT_Image_Jun_3,_2026,_01_59_21_PM.png" alt="Megapack Acompañante Pedagógico Eficiente" className="w-[80%] max-w-2xl rounded-xl shadow-2xl cursor-pointer hover:scale-[1.02] transition-transform" onClick={onCTAClick} data-id="element-88" />
        </div>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-center text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-89">
          El sistema completo de plantillas, registros, modelos profesionales y
          casuísticas resueltas para acompañantes pedagógicos, APND y maestras
          integradoras.
        </p>

        {/* Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8 max-w-3xl mx-auto" data-id="element-90">
          {['📄 100% PDF', '⚡ Acceso Inmediato', '📚 4 Tomos + 6 Bonos', '🗂️ Plantillas Editables'].map((badge, index) => <div key={index} className="bg-white border-2 border-teal-600 rounded-lg p-3 text-center font-semibold text-sm text-gray-800" data-id="element-91">
              {badge}
            </div>)}
        </div>

        {/* CTA Button */}
        <div className="flex justify-center mb-8" data-id="element-92">
          <button onClick={onCTAClick} className="bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 px-8 rounded-lg text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-93">
            Empezá a ahorrar horas
          </button>
        </div>

        {/* Rating */}
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-94">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-95" />)}
          <span className="text-lg font-bold text-gray-800 ml-2" data-id="element-96">4.8/5.0</span>
        </div>

        {/* Compact Opinions */}
        <div className="space-y-2 max-w-2xl mx-auto" data-id="element-97">
          {opinions.map((opinion, index) => <div key={index} className="bg-white rounded-lg p-3 shadow-sm border border-gray-200" data-id="element-98">
              <div className="flex items-center gap-1 mb-1" data-id="element-99">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-yellow-400 text-yellow-400" data-id="element-100" />)}
              </div>
              <p className="text-sm text-gray-700" data-id="element-101">
                <span className="font-semibold" data-id="element-102">{opinion.name}:</span>{' '}
                {opinion.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}